import { lazy } from 'react';

const RELOADED_KEY = 'mangrove:chunk-reload';

const storage = {
  get: () => {
    try {
      return window.sessionStorage.getItem(RELOADED_KEY);
    } catch {
      return null;
    }
  },
  set: (value) => {
    try {
      if (value) window.sessionStorage.setItem(RELOADED_KEY, value);
      else window.sessionStorage.removeItem(RELOADED_KEY);
    } catch {
      // Storage unavailable (e.g. blocked): we just won't auto-reload.
    }
  },
};

/**
 * React.lazy for a page, surviving deploys. Each deploy renames the page
 * bundles, so a tab opened before it asks for files that no longer exist
 * (ChunkLoadError). Reload once to fetch the new build; if the page still
 * can't load, rethrow so the error boundary shows a message instead.
 */
const lazyPage = (load) =>
  lazy(() =>
    load()
      .then((module) => {
        storage.set(null);
        return module;
      })
      .catch((error) => {
        if (error?.name === 'ChunkLoadError' && !storage.get()) {
          storage.set('1');
          window.location.reload();
          return new Promise(() => {}); // keep showing the spinner until the reload
        }
        throw error;
      })
  );

export default lazyPage;
